

import { BANKING_DETAILS_SET_VALUE } from "../../../actions/kaMetlhaFuneralCover/bankingDetails";
import { PURCHASE_PERSONAL_DETAILS_SET_VALUE } from "../../../actions/kaMetlhaFuneralCover/personalDetails";
import { QUOTE_DETAILS_FORM_SET_VALUE } from "../../../actions/kaMetlhaFuneralCover/quote";
import { UPLOAD_DOCUMENTS_SET_VALUE } from "../../../actions/kaMetlhaFuneralCover/uploadDocuments";
import { bankingDetailsValidations } from "./bankingDetails";
import { purchaseJourneyPersonalDetailsValidation } from "./personalDetails";
import { quoteDetailsValidation } from "./quoteDetails";
import { uploadDocumentsValidation } from "./uploadDocuments";

export const kaMetlhaFuneralValidations = (store, next, action) => {

  if (action.type.startsWith(QUOTE_DETAILS_FORM_SET_VALUE)) {
    return quoteDetailsValidation(store, next, action);
  }
  if(action.type.startsWith(PURCHASE_PERSONAL_DETAILS_SET_VALUE)){
    return purchaseJourneyPersonalDetailsValidation(store, next, action)
  }
  if(action.type.startsWith(BANKING_DETAILS_SET_VALUE)){
    return bankingDetailsValidations(store, next, action)
  }
  if(action.type.startsWith(UPLOAD_DOCUMENTS_SET_VALUE)){
    return uploadDocumentsValidation(store, next, action)
  }
  return null;
};
